import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=3c2148e8&scoped=true&"
var script = {}
import style0 from "./spinner.vue?vue&type=style&index=0&id=3c2148e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2148e8",
  null
  
)

export default component.exports